$.fn.setupLookup = function () {
    /// <summary>Sets up a lookup control using its data attributes</summary>
    /// <returns type="JQuery">The JQuery element</returns>

    this.each(function () {

        var me = $(this),
            txt = $('[data-role="lookupText"]', me);

        // CFM-619 - fix auto complete issues - prevent browser autofill from interfering with lookup result selection and input
        txt.ensureDisabledAutoComplete();

        $('[data-role="lookupOpen"]', me).off('click').click(function () {

            if (txt.prop('disabled')) return;

            if (cafm.lookup.openingTimeout) {

                clearTimeout(cafm.lookup.openingTimeout);
            }

            cafm.lookup.openingTimeout = setTimeout(function () {

                try {

                    txt.removeData('acActive'); // ensure auto complete active flag is removed (in case it didn't get removed)
                
                    cafm.lookup.openLookup({
                        url: me.data('path'),
                        title: me.data('title'),
                        lookup: me
                    });
                }
                finally {

                    delete cafm.lookup.openingTimeout;
                }

            }, isTouch ? 1000 : 1);
        });
        $('[data-role="lookupClear"]', me).off('click').click(function (e) {

            $(e.target).clearLookup();
        });
        txt.off('focus.cafmlu').on('focus.cafmlu', function (e) {

            var tbox = $(this),
                val = $(e.target).val(),
                wm = tbox.attr('placeholder');

            txt.data('currentText', val == wm ? '' : val)
        });
        txt.off('blur.cafmlu').on('blur.cafmlu', function (e) {

            var tbox = $(this),
                v = tbox.val(),
                wm = tbox.attr('placeholder');

            if (txt.data('currentText') && (!v || wm == v) && !me.isLocalityLookup()) {
                
                cafm.lookup.setLookup({
                    lookup: me,
                    value: cafm.guid.empty,
                    text: ''
                });
            }
        });

        var sl;
        if (me.data('showlist')) {

            sl = me.find('.lcSelectedList .simpleList');
        }

        if (!txt.prop('disabled')) {
            
            if (isMobile) {

                me.find('.btn').css('visibility', 'visible');

                me.click(function () {

                    if (sl) {

                        var bli = sl.getBasicListItems();
                        if (bli && bli.length > 1) {
                            sl.toggle();
                        }
                        else {

                            sl.hide();
                        }
                    }
                });
            }
            else {

                me.off('hover').hover(function (e) {

                    if (txt.prop('disabled')) return;
                    $('.btn', me).css('visibility', 'visible');

                    if (sl) {

                        var bli = sl.getBasicListItems();
                        if (bli && bli.length > 1) {
                            sl.show();
                        }
                    }

                }, function (e) {

                    $('.btn', me).css('visibility', 'hidden');

                    if (sl) {

                        sl.hide();
                    }
                });
            }
        }
        else if(isMobile) {

            me.find('.btn').css('visibility', 'hidden');
        }

        txt.attr('title', txt.textVal());
    });
    return this;
}
$.fn.openLookup = function () {
    /// <summary>Opens a lookup when this called from its wrapper element</summary>
    /// <returns type="JQuery">The JQuery element</returns>

    var me = $(this);
    $('[data-role="lookupOpen"]', me).click();
    return me;
}
$.fn.clearLookup = function (e) {
    /// <summary>Clears a lookup and optionally while suppressing its change events</summary>
    /// <param name="e" type="Object">Options object</param>
    /// <returns type="JQuery">The JQuery element</returns>

    this.each(function () {

        var lu = $(this);
        if (!lu.hasClass('cfLookup')) {

            lu = lu.parents('.cfLookup');
        }

        if (!lu.length) {

            return;
        }

        function doClear() {
            
            var txtField = $('input[data-role="lookupText"]', lu);
            var islocality = lu.data('islocality');

            if (!lu.data('showlist')) {

                var luText = $(`.${cafm.res.consts.CssClass_LookupInput}`, lu).textVal();

                if (!luText) {

                    return;
                }

                var valField = $('input[data-role="lookupValue"]', lu);
                var resetVal;
                var resetTxt;

                if (!islocality) {

                    resetVal = cafm.guid.empty;
                    resetTxt = '';
                }
                else {
                    if (!txtField.data('allownulllocality')) {
                        resetVal = cafm.auth.companyId();
                        resetTxt = cafm.auth.companyName();
                    }
                }

                if (!e || !e.suppressEvents) {
                                        
                    var lr = valField.data('lookupremove');
                    var preventChangeEvent;
                    if (lr) {

                        preventChangeEvent = cafm.handlers.exe(lr, { target: valField, val: resetVal, event: e });
                    }

                    if (!preventChangeEvent) {

                        valField.changeVal(resetVal);
                        txtField.changeVal(resetTxt);
                    }
                }
                else {

                    valField.val(resetVal);
                    txtField.val(resetTxt);
                }

                if (islocality && (e && !e.suppressEvents)) {
                    
                    var integrate = $('input[data-role="lookupText"]', lu).data('integrate');
                    if (integrate) {

                        cafm.hi.resetHierarchyToCompany();
                    }
                }
            }
            else {

                cafm.forms.basicList.clear({

                    listTarget: $('.simpleList', lu),
                    hideAfterClear: true
                });
            }

            txtField.removeData('selectedText');
            txtField.removeData('acActive');
            txtField.attr('title', txtField.textVal());
        }

        if (e && e.timeout)
            setTimeout(doClear, e.timeout);
        else
            doClear();
    });

    return this;
}
$.fn.getLookupSelectedItems = function () {

    var lu = $(this);
    var items;

    if (lu.data('multi')) {

        var lul = lu.find('.cfLookupList');
        items = lul.data('items');
        if (items && isFunc(items.toJSON)) {

            items = items.toJSON();
        }
        return items;
    }
    else {

        var v = lu.find('input[data-role="lookupValue"]').val();
        var t = lu.find('input[data-role="lookupText"]').textVal();
        items = v && t ? [{

            value: v,
            text: t
        }] : [];
        return items;
    }
}
$.fn.isLookup = function () {

    return this.hasClass(cafm.res.consts.CssClass_LookupInput) || this.closestField().hasClass('cfLookup');
}
$.fn.isLocalityLookup = function () {

    return this.closestField().hasClass('forLocality');
}
$.fn.isIntegratedLocalityLookup = function () {
    
    var field = this.closestField(), tbox = field.find('input[data-role="lookupText"]');
    return field.isLocalityLookup() && tbox.data('integrate');
}

/// <summary name='cafm.lookup' type='Object'>CAFM Lookup container object</summary>
cafm.lookup = {

    searchAction: function (container) {

        var searchAction = container.data('searchAction');
        if (!searchAction) {

            var containerId = container.attr('id');
            var action = container.data('action');

            searchAction = new cafm.actions.Action({
                id: containerId,
                elementId: containerId,
                loaderSelector: '#{0} .lookupGridPlc'.format(container.attr('id')),
                method: 'POST',
                requestDelay: 500,
                url: action,
                statusCodeFuncs: {

                    200: function (r, s, m) {

                        cafm.lookup.listDataSourceRead(container, isUndefined(r.length) ? r.Items : r)
                    }
                }
            });
            container.data('searchAction', searchAction);
        }

        return searchAction;
    },
    open: function (wrapperId) {
        /// <summary>Opens a lookup by the lookup wrappers client id</summary>
        /// <param name="wrapperId" type="String">The lookup wrapper client id</param>

        $('#{0}'.format(wrapperId)).openLookup();
    },
    openLookup: function (opts) {
        /// <summary>Called to open the lookup search view</summary>
        /// <param name="opts" type="Object">The open options</param>

        $('input[data-role="lookupValue"]', opts.lookup).blur().val();

        var lt = $('input[data-role="lookupText"]', opts.lookup),
            isLocality = opts.url == 'LocalityLookup',
            integrate = lt.data('integrate'),
            multi = opts.lookup.data('multi'),
            requiredLocType = lt.data('requiredlocalitytype'),
            requireBookable = lt.data('requirebookablerooms'),
            usage = lt.data('usage'),
            defaultViewModel = cafm.lookup.helpers.getBaseDefaultViewModel();
        url = [];

        if (!isLocality) {

            url.push(cafm.url.get(opts.url));
        }
        else {

            var localityId = $('input[data-role="lookupValue"]', opts.lookup).val();

            url.push(opts.url);

            if (localityId) {

                url.push(localityId);
            }

            url = url.join('/');
        }
        
        if (multi || usage || integrate || requiredLocType) {

            var qs = [];

            if (integrate) {

                qs.push('integrate=true');
            }

            if (multi) {

                qs.push('multiple=true');
            }

            if (usage) {

                qs.push('usage={0}'.format(usage));
            }

            if (requiredLocType) {

                qs.push('requiredLocalityType={0}'.format(requiredLocType));
            }

            if (requireBookable) {

                qs.push('requireBookableRooms={0}'.format(requireBookable));
            }

            if (qs.length) {

                url += ('?' + qs.join('&'));
            }
        }


        var vo = {
            url: cafm.url.get(isArray(url) ? url.join('') : url),
            viewModel: defaultViewModel,
            viewModelTarget: '.lookupFilters',
            initialText: cafm.res.str.TextPreparingForm,
            onInit: function (pnl) {

                cafm.lookup.handlers.initLookup(pnl, opts.lookup);
            },
            isForm: opts.url != 'LocalityLookup'
        }

        if (!isMobile) {

            var vh = cafm.util.viewPortHeight(80);
            vo.winOptions = {
                width: !isLocality ? cafm.util.viewPortWidth(60) : 500,
                height: !isLocality ? vh : 300,
                minHeight: !isLocality ? (isTouch ? vh : 580) : 0,
                modal: true,
                draggable: true,
                title: opts.title
            };
        }
        else {

            vo.winTitle = opts.title;
        }

        if (!isLocality) {

            vo.onLoad = function (pnl) {

                var listView = $('.cLv', pnl).getLv();

                if (listView && listView.options.autoBind) {

                    $('.lookupGrid', pnl).show();
                }
            }
        }

        cafm.views.openActionWindow(vo);
    },
    removeSelectedItem: function(e) {

        var c = e.listTarget.parents('.lookupSearch');
        var lu = c.data('currentLookup');

        if (!e.item.data('new')) {

            if (lu.data('showlist')) {

                cafm.forms.basicList.remove({

                    listTarget: lu.find('.simpleList')
                }, e.item);
            }
            else {

                lu.clearLookup();
            }
        }

        if (!$('.simpleListItem', e.listTarget).length) {

            $('.lookupSelected', c).hide();
        }

        var lst = $('.cLv', c).data('kendoListView');
        if (lst) {

            lst.deselectItem(e.item.data('itemuid'));
        }
    },
    closeLookup: function (container) {

        // get ref to opening lookup
        var lu = container.data('currentLookup');

        // cache the last lookup criteria
        cafm.lookup.lastCriteria = $('.lookupFilters', container).getViewModel();

        // wait to close the action window
        setTimeout(function () {

            cafm.views.closeActionWindow(container.parents('.actionPanel:first'), isMobile ? function () {

                // focus opening lookup if there is no other lookup open
                if (!$('.lookupSearch').length) {

                    $('html, body').scrollTop(lu.offset().top);
                }
            } : null);            
        }, 500);

    },
    setLookup: function (e) {

        var lu = e.lookup;
        var valueEl = $('input[data-role="lookupValue"]', lu);
        var textEl = $('input[data-role="lookupText"]', lu);
        var v = e.value;
        var t = e.text;

        if (!lu.data('showlist')) {

            lu.queue([
                function (next) {

                    valueEl.changeVal(v);

                    cafm.util.callFunction(lu.data('onLookupSelected'), e);

                    next();
                },
                function () {

                    textEl.changeVal(t);
                    textEl.attr('title', t);
                }
            ]);
        }        
        else {

            var lt = lu.find('.cfLookupList');

            if (e.items) {
                
                cafm.forms.basicList.add({

                    listTarget: lt,
                    dataItem: e.items
                });
            }
            else {

                cafm.forms.basicList.add({

                    listTarget: lt,
                    dataItem: {
                        value: v,
                        text: t
                    }
                });
            }

            cafm.util.callFunction(lu.data('onLookupSelected'), e);
        }

        // update selectedText as this is used for text search lookups
        textEl.data('selectedText', t);
    },
    handlers: {
        
        close: function (e) {
            /// <summary>Closes the lookup search</summary>
            /// <param name="e" type="Object">Event object</param>

            var container = $('.lookupSearch', $(e.target).closest('.actionWindow,.actionPanel'));
            cafm.lookup.closeLookup(container);
        },
        initLookup: function (pnl, lookup) {
            /// <summary>Prepares the lookup search view</summary>

            var container = $('.lookupSearch', pnl).data('currentLookup', lookup),
                isLocality = lookup.isLocalityLookup(),
                multi = lookup.data('multi');

            lookup.attr('data-lookupid', container.attr('id'));

            setTimeout(function () {

                var filterTextboxes = $('.lookupFilters input[type="text"]', container);
                filterTextboxes.enterPressed(function (e) {

                    $(e.target).trigger('change');
                    setTimeout(function () {

                        $('button.searchBtn', container.parents('.k-window:first')).click();
                    }, 250);
                    return false;
                });
            }, 250);

            if (multi || isLocality) {

                var selectBtn = $('.selectBtn', container.closest('.actionWindow,.actionPanel'));

                if (!isLocality) {

                    selectBtn.attr('disabled', true);
                }
                selectBtn.show();

                if (isLocality) {
                    let showDescription = lookup.find(`.${cafm.res.consts.CssClass_LookupInput}`).data('showdescription');
                    container.data('idKey', 'LocalityID');
                    container.data('textKey', showDescription ? 'LocalityDescription' : 'LocalityTrail');
                }
            }

            if (!isLocality || multi) {

                var selected = lookup.getLookupSelectedItems();
                var sl = $('.lookupSelectedList .simpleList', container);

                if (sl.length) {

                    sl.setupBasicList({

                        dataItem: selected,
                        onRemove: cafm.lookup.removeSelectedItem,
                        forceSetup: true
                    });
                }
            }

            if (selected && selected.length) {

                $('.lookupSelected', container).show();
            }
        },
        loadLookup: function (o) {
            /// <summary>Initialises the lookup search</summary>
            /// <param name="o" type="Object">Lookup search options object</param>

            var container = $('#' + o.containerElementId),
                filters = $('.lookupFilters', container),
                listView = $('.cLv', container),
                lookup = container.data('currentLookup'),
                lookupText = $('input[data-role="lookupText"]', lookup),
                isLocality = container.data('localitylookup') == true,
                criteriaViewModel = filters.getViewModel(),
                controlCriteria = lookupText.getCriteria();

            container.data('idKey', o.idKey);
            container.data('textKey', o.textKey);

            $.extend(criteriaViewModel, o.defaultCriteria);

            if (controlCriteria && criteriaViewModel) {

                criteriaViewModel = $.extend(criteriaViewModel, controlCriteria);
            }

            // apply exclude ids to search requests using list view pre data source read handler
            if (!isLocality && criteriaViewModel) {

                var associateId = lookupText.data('associateid'),
                    allowDuplicates = lookupText.data('allowduplicates'),
                    idField = lookupText.data('associateidfield'),
                    locId = lookup.data('localityid');

                // ensure locality ID
                if (locId) {

                    criteriaViewModel.LocationID = locId;
                }

                filters.bindViewModel(criteriaViewModel);

                criteriaViewModel = filters.getViewModel();

                // pre-fetch if there is one
                cafm.util.callFunction(container.data('onprefetch'), criteriaViewModel, filters);

                // now set the criteria on the ds element
                listView.setCriteria(criteriaViewModel);

                // check for associate list and allow duplicates flag
                if (associateId && idField && allowDuplicates === false) {

                    // pre data source read handler function
                    let beforeSend = r => {
                        // set exlude IDs header on request
                        cafm.web.funcs.setRequestExcludeIds({
                            dataSource: $('#' + associateId).getLv().dataSource,
                            idField: idField,
                            request: r
                        });
                    }

                    // set the pre data source read handler
                    listView.data('predatasourceread', beforeSend);
                }
            }

            // now set the criteria as the default view model (used for reset search etc)
            if (criteriaViewModel) {

                container.data('defaultViewModel', cafm.util.clone(criteriaViewModel.toJSON(), true));
            }
            
            // call onload if there is one
            cafm.util.callFunction(container.data('onload'), {
                container: container,
                lookup: lookup
            });
        },
        listDataBound: function (e) {

            var el = e.sender.element;

            if (!isJQuery(el)) {

                el = $(el);
            }

            var container = el.closest('.lookupSearch');
            var currentLookup = container.data('currentLookup');

            if (currentLookup.data('multi')) {

                el.find('.cLvIt').removeClass('k-state-selected').attr('aria-selected', 'false');

                var uids = el.getLvWrapper().getSelectedItemUids();
                if (uids && uids.length > 0) {

                    uids.forEach(function (uid) {

                        el.find('.cLvIt[data-uid="{0}"]'.format(uid)).addClass('k-state-selected').attr('aria-selected', 'true');
                    });
                }
            }

            var total = e.sender.dataSource ? e.sender.dataSource.total() : 0;
            if (total <= e.sender.dataSource.pageSize()) {

                $('.k-pager-wrap .k-link, .k-pager-wrap .k-pager-numbers', container).hide();
            }
            else {

                $('.k-pager-wrap .k-link, .k-pager-wrap .k-pager-numbers', container).show();
            }

            if (isMobile) {
                var ap = container.closest('.mobileActionPanel'),
                    lookupButtons = $('.lookupButtons', ap);
                ap.css('padding-bottom', lookupButtons.outerHeight() + 'px');
            }
        },
        listSelectionChanged: function (e) {
            /// <summary>Handles row selection on the lookup search grid</summary>
            /// <param name="e" type="Object">Selection event object</param>

            var container = e.sender.element.closest('.lookupSearch');
            var currentLookup = container.data('currentLookup');

            if (currentLookup.data('multi')) {

                var wrapper = e.sender.element.getLvWrapper();
                var uids = wrapper.getSelectedItemUids();

                if (!uids) {

                    uids = [];
                }

                var selectedList = container.find('.lookupSelectedList .simpleList');

                $.each(e.sender.items(), function (i, item) {

                    item = $(item);
                    var uid = item.data('uid');
                    var ind = uids.indexOf(uid);
                    var dataItem = e.sender.dataSource.getByUid(uid);

                    if (item.hasClass('k-state-selected')) {

                        cafm.forms.basicList.add({
                            listTarget: selectedList,
                            dataItem: {
                                value: dataItem.ID,
                                text: dataItem.Description
                            },
                            itemAttr: {
                                'data-new': true,
                                'data-itemuid': uid
                            }
                        });

                        return true;
                    }
                    else if (ind > -1) {

                        uids.splice(ind, 1);
                    }

                    var selectedListItem = selectedList.find('[data-value="{0}"][data-new]'.format(dataItem.ID));

                    if (selectedListItem.length) {

                        cafm.forms.basicList.remove({
                            listTarget: selectedList
                        }, selectedListItem);
                    }
                });

                var selectBtn = container.closest(isMobile ? '.actionPanel' : '.actionWindow').find('.selectBtn');

                if (uids.length) {

                    if (selectBtn.attr('disabled')) {

                        selectBtn.removeAttr('disabled');
                    }
                }
                else {

                    selectBtn.attr('disabled', 'disabled');
                }

                if ($('.simpleListItem', selectedList).length) {

                    $('.lookupSelected', container).show();

                    var c = $('.selectedCollapser', container);
                    if (!c.attr('data-expanded') || c.attr('data-expanded') == 'false') {

                        cafm.forms.elementState.setDescription(c);
                    }
                }
                else {

                    $('.lookupSelected', container).hide();
                }
            }
            else {

                cafm.lookup.handlers.select(e);
            }
        },
        onPersonPreFetch: function (criteria) {

            if (criteria.TradeID && criteria.TradeID.value) {
                criteria.set('TradeID', criteria.TradeID.value);
            }
        },
        reset: function (e) {
            /// <summary>Resets the lookup search grid and filters</summary>
            /// <param name="e" type="Object">Event object</param>

            var container = $('.lookupSearch', $(e.target).closest('.actionWindow,.actionPanel')),
                lf = $('.lookupFilters', container),
                bdvm = container.data('defaultViewModel'),
                dvm = cafm.lookup.helpers.getBaseDefaultViewModel(),
                filterCollapser = $('.filterCollapser', container);

            if (!cafm.util.isTrue(filterCollapser.attr('data-expanded'))) {

                filterCollapser.click();
            }

            // merge default view model into base view model
            $.extend(bdvm, dvm);

            // rebind default view model
            lf.bindViewModel({
                viewModel: bdvm
            });

            // refresh the lookup results
            cafm.lookup.helpers.refreshResults(container);
        },
        search: function (e) {
            /// <summary>Performs the lookup search action</summary>
            /// <param name="e" type="Object">Event object</param>

            var container = $('.lookupSearch', $(e.target).closest('.actionWindow,.actionPanel')),
                lookup = container.data('currentLookup');
        
            // if multi selection
            if (lookup.data('multi')) {

                var luList = $('.lookupSelectedList .simpleList', container);
                var luSelected = luList.data('items');

                if(cafm.util.hasItem(luSelected)) {
                
                    var preSelected = lookup.getLookupSelectedItems();
                    var toRemove = [];

                    if (cafm.util.hasItem(preSelected)) {

                        $.each(luSelected, function (i, item) {

                            var isPre = cafm.util.exists(preSelected, function (preItem) {

                                return preItem.value == item.value;
                            });

                            if (!isPre) {

                                toRemove.push(item);
                            }
                        });
                    }
                    else {

                        toRemove = luSelected;
                    }

                    if (cafm.util.hasItem(toRemove)) {

                        cafm.forms.basicList.remove({

                            listTarget: luList,
                            suppressEvent: true
                        }, toRemove);
                    }


                    if (toRemove.length >= luSelected.length) {

                        $('.lookupSelected', container).hide();
                    }
                }
            }

            // refresh the lookup results
            cafm.lookup.helpers.refreshResults(container);
        },
        select: function (e) {

            var target = e.sender ? e.sender.element : e.currentTarget,
                container = $('.lookupSearch', $(target).closest('.actionWindow,.actionPanel')),
                items, isLocality, locality;

            isLocality = container.data('localitylookup') == true;

            if (!isLocality) {

                items = cafm.lookup.helpers.getSelectedRows(container);
                $('.cLvWrap', container).setSelectedItemUids(cafm.util.transformArray(items, function (item) {

                    return item.uid;
                }));
            }
            else {

                locality = $('#localityLookup').getViewModel();

                // check required locality type is selected
                if (container.data('requiredlocalitytype')) {
                    var locId, locName;
                    switch (container.data('requiredlocalitytype')) {
                        case cafm.enums.LocalityTypeData.WorkGroup:
                            locId = locality.WorkGroupID;
                            locName = cafm.res.str.LabelWorkGroup;
                            break;
                        case cafm.enums.LocalityTypeData.Room:
                            locId = locality.RoomID;
                            locName = cafm.res.str.LabelRoom;
                            break;
                        case cafm.enums.LocalityTypeData.Space:
                            locId = locality.SpaceID;
                            locName = cafm.res.str.LabelSpace;
                            break;
                        case cafm.enums.LocalityTypeData.Zone:
                            locId = locality.ZoneID;
                            locName = cafm.res.str.LabelZone;
                            break;
                        case cafm.enums.LocalityTypeData.Floor:
                            locId = locality.FloorID;
                            locName = cafm.res.str.LabelFloor;
                            break;
                        case cafm.enums.LocalityTypeData.Building:
                            locId = locality.BuildingID;
                            locName = cafm.res.str.LabelBuilding;
                            break;
                        default:
                            locId = locality.LocationID;
                            locName = cafm.res.str.LabelLocation;
                            break;
                            
                    }
                    if (!cafm.util.guidHasValue(locId)) {
                        cafm.msg.showMessageInWindow({
                            title: cafm.res.str.TemplatePleaseSelectA0.format(locName),
                            type: cafm.enums.MessageType.Error
                        })
                        return;
                    }
                }

                items = [locality];
            }

            if (!items.length) {

                return;
            }

            var idKey = container.data('idKey'),
                textKey = container.data('textKey'),
                vals = [],
                txts = [];

            $.each(items, function (i, item) {
                vals.push(item[idKey]);
                txts.push(item[textKey]);
            });

            var vs = container.data('validateSelection');
            if (isFunc(vs)) {

                var lf = $('.lookupFilters', container);
                var valid = vs({
                    criteria: lf.getViewModel(),
                    items: items
                });

                if (valid === false) {

                    return;
                }
            }

            var lu = container.data('currentLookup'),
                listed = lu.data('showlist');

            if (!listed) {

                var v = vals.join(';'),
                    t = txts.join(', '),
                    integrate = $('input[data-role="lookupText"]', lu).data('integrate'),
                    selectTime = container.data('selectTime');

                if (selectTime) {

                    clearTimeout(selectTime);
                }

                if (e.preventDefault) {

                    e.preventDefault();
                }

                container.data('selectTime', setTimeout(function () {

                    cafm.lookup.setLookup({
                        lookup: lu,
                        value: v,
                        text: t,
                        dataItem: items
                    });

                    if (isLocality && integrate) {

                        if (isMobile) {

                            cafm.hi.localityChanged(locality);
                        }
                        else {

                            cafm.hi.setCurrentLocality({
                                locality: locality
                            });
                        }

                    }
                }, 250));
            }
            else {

                var listItems = cafm.util.transformArray(items, function (item) {

                    return {
                        value: item[idKey],
                        text: item[textKey]
                    }
                });

                cafm.lookup.setLookup({
                    lookup: lu,
                    items: listItems,
                    dataItem: items
                });
            }

            // show loader over the container so nothing can be pressed twice
            container.getParentWindowElement().showLoader()

            cafm.lookup.closeLookup(container);
        },
        treeDataSourcePreExecute: function (args) {

            args.options.Criteria.LocalityId = args.element.closest('.lookupSearch').data('currentLookup').data('localityid');
            args.options.Criteria.StandardWorkOrderGroupId = args.parentId;
        },
        treeSelectionChanged: function (args) {

            if (args.item.hasClass('tvFolder')) return;

            var container = args.tree.element.closest('.lookupSearch'),
                selected = args.tree.select();

            if (selected && selected.length) {
                
                var l = container.data('currentLookup'),
                    v = selected.data('key'),
                    t = selected.find('> div > .k-in').text(),
                    st = container.data('selectTime');

                if (st) clearTimeout(st);

                container.data('selectTime', setTimeout(function () {

                    cafm.lookup.setLookup({
                        lookup: l,
                        value: v,
                        text: t
                    });

                }, 250));
            }

            // show loader over the container so nothing can be pressed twice
            container.getParentWindowElement().showLoader();

            cafm.lookup.closeLookup(container);
        }
    },
    helpers: {

        getBaseDefaultViewModel: function() {

            return {
                search: cafm.lookup.handlers.search,
                reset: cafm.lookup.handlers.reset,
                select: cafm.lookup.handlers.select,
                close: cafm.lookup.handlers.close
            };
        },
        getSelectedRows: function (container, currentLookup) {
            /// <summary>Gets selected lookup grid rows</summary>

            if (!currentLookup) {

                currentLookup = container.data('currentLookup');
            }

            var luLv = $(".cLv", container).data('kendoListView');
            var items = luLv.getSelected();

            if (isArray(items)) {

                return items;
            }
            else if (isNullOrUndefined(items)) {

                return [];
            }
            else {

                return [items];
            }
        },
        refreshResults: function (container) {

            var lookup = container.data('currentLookup'),
                locId = lookup.data('localityid'),
                filters = $('.lookupFilters', container),
                listView = $('.cLv', container),
                luCriteria = filters.getViewModel();

            // ensure locality ID
            if (locId) {

                luCriteria.LocationID = locId;
            }

            // pre-fetch if there is one
            cafm.util.callFunction(container.data('onprefetch'), luCriteria, filters);

            // now set the criteria on the ds element
            listView.setCriteria(luCriteria);

            // ensure the list is visible
            $('.lookupGrid', container).show();

            // get the list set criteria and refresh
            $('.cLv', container).refreshListDS({ resetPage: true });
        }
    }
}